







































import { Vue, Component } from "vue-property-decorator";
import { BModal } from "bootstrap-vue/src/components/modal";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import axios from "@/utils/axios";

interface InsightBucket {
  id: string;
  label: string;
  question: string;
  path: string;
}

const BUCKETS = [
  { id: "general-overview", path: "explain-general-overview" },
  { id: "performance", path: "explain-performance" },
  { id: "category", path: "explain-category" },
  { id: "pre-exam-performance", path: "explain-pre-exam-performance" },
  { id: "volume", path: "explain-volume" },
];

const GENERAL_OVERVIEW_BUCKET_ID = "general-overview";

@Component({
  components: {
    FscSimpleCard,
  },
})
export default class KiPilotTheorieInsights extends Vue {
  public name = "KiPilotTheorieInsights";

  public currentStudentEducationId = "";

  public currentStudentName = "";

  public selectedBucketId = GENERAL_OVERVIEW_BUCKET_ID;

  public answers: Record<string, string> = {};

  public errors: Record<string, string> = {};

  // Loading id per bucket
  public loadingIds: string[] = [];

  public open(studentEducationId: string, studentName = "", studentSurname = ""): void {
    this.currentStudentEducationId = studentEducationId;
    this.currentStudentName = [studentName, studentSurname].filter(Boolean).join(" ");
    this.answers = {};
    this.errors = {};
    this.loadingIds = [];
    this.selectedBucketId = GENERAL_OVERVIEW_BUCKET_ID;
    (this.$refs.insightsModal as BModal).show();
  }

  public get modalTitle(): string {
    return this.currentStudentName
      ? (this.$t("ki_pilot_theorie.insights_title", { studentName: this.currentStudentName }) as string)
      : (this.$t("ki_pilot_theorie.insights_title_fallback", { studentEducationId: this.currentStudentEducationId }) as string);
  }

  public get buckets(): InsightBucket[] {
    return BUCKETS.map((bucket) => ({
      ...bucket,
      label: this.$t(`ki_pilot_theorie.insights_buckets.${bucket.id}.label`) as string,
      question: this.$t(`ki_pilot_theorie.insights_buckets.${bucket.id}.question`) as string,
    }));
  }

  public get selectedBucket(): InsightBucket {
    return this.buckets.find((bucket) => bucket.id === this.selectedBucketId) || this.buckets[0];
  }

  public get isSelectedLoading(): boolean {
    return this.loadingIds.includes(this.selectedBucket.id);
  }

  public get selectedAnswer(): string {
    return this.answers[this.selectedBucket.id] || "";
  }

  public get selectedError(): string {
    return this.errors[this.selectedBucket.id] || "";
  }

  public async check(): Promise<void> {
    const bucket = this.selectedBucket;
    if (this.loadingIds.includes(bucket.id)) return;

    this.loadingIds = [...this.loadingIds, bucket.id];
    this.errors = { ...this.errors, [bucket.id]: "" };
    try {
      const response = await axios.get(`examiner/${bucket.path}/${this.currentStudentEducationId}`);
      this.answers = { ...this.answers, [bucket.id]: response.data };
    } catch (e) {
      this.errors = { ...this.errors, [bucket.id]: this.$t("ki_pilot_theorie.insights_error") as string };
    } finally {
      this.loadingIds = this.loadingIds.filter((id) => id !== bucket.id);
    }
  }
}
